import React, { createContext } from 'react';

export const { Provider, Consumer } = createContext({
    page: {
        category: {},
        pageInfo: {},
    },
});

export function withAnalytics(Component) {
    return function AnalysedComponent(props) {
        return <Consumer>{(analytics) => <Component {...props} analytics={analytics} />}</Consumer>;
    };
}
